/**
 * Two dimensional Cartesian coordinate
 */
export interface Cartesian {
  x: number,
  y: number
}

export interface Geodetic {
  lat: number,
  lng: number
}
/**
 * Two dimensional Cartesian coordinate with inverted y-axis compared to Cartesian coordinates.
 */
export interface Point {
  x: number,
  y: number
}

/**
 * Two dimensional (relative) Cartesian coordinate with inverted y-axis compared to Cartesian coordinates.
 * This interface is merely to distinguish between Points and actual Pixels.
 */
export interface Pixel {
  x: number,
  y: number
}

export type Coordinate = [number, number];

export interface CartesianBounds {
  southWest: Cartesian,
  northEast: Cartesian
}

export interface GeodeticBounds {
  southWest: Geodetic,
  northEast: Geodetic
}

export interface MapProjection {
  fromPointToLatLng(xy: Point): Geodetic,
  fromLatLngToPoint(latLng: Geodetic): Point
}
export interface PixelProjection {
  fromPixelToLatLng(xy: Pixel): Geodetic,
  fromLatLngToPixel(latLng: Geodetic): Pixel
}

export class Point2D implements Cartesian {
  constructor(public x: number, public y: number) { }

  toString(): string {
    return `Point2D:{ x:${this.x}, y:${this.y} }`;
  }
  equals(o: Point2D): boolean {
    if (o != null) {
      return o.x === this.x && o.y === this.y;
    }
    return false;
  }
  compareTo(o: Point2D): number {
    let result: number = (this.y - o.y);
    if (result === 0.0) {
      result = this.x - o.x;
    }
    return (result < 0 ? -1 : result > 0 ? +1 : 0);
  }
  compare(o0: Point2D, o1: Point2D): number {
    let result: number = (o0.y - o1.y);
    if (result === 0.0) {
      result = o0.x - o1.x;
    }
    return (result < 0 ? -1 : result > 0 ? +1 : 0);
  }
}

export class LatLng implements Geodetic {
  constructor(public lat: number, public lng: number) { }

  toString(): string {
    return `LatLng:{ lat:${this.lat}, lng:${this.lng} }`;
  }
  equals(o: LatLng): boolean {
    if (o != null) {
      return o.lat === this.lat && o.lng === this.lng;
    }
    return false;
  }
  compareTo(o: LatLng): number {
    let result: number = (this.lat - o.lat);
    if (result === 0.0) {
      result = this.lng - o.lng;
    }
    return (result < 0 ? -1 : result > 0 ? +1 : 0);
  }
  compare(o0: LatLng, o1: LatLng): number {
    let result: number = (o0.lat - o1.lat);
    if (result === 0.0) {
      result = o0.lng - o1.lng;
    }
    return (result < 0 ? -1 : result > 0 ? +1 : 0);
  }

}

